module.exports = __webpack_public_path__ + "au.fd8563ef5085523706a4.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/au.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/au.svg
// module chunks = styles